const actionsRoutes = {
	name: 'modules.actions',
	path: '/actions',
	redirect: { name: 'actions.actions' },
	component: () => import('#modules/actions/ActionsModule.vue'),
	meta: { requiresAuth: true, permissions: ['actions'] },
	children: [
		{
			name: 'actions.permalinks',
			path: 'r',
			children: [
				{
					name: 'actions.permalinks.show',
					path: ':actionId(\\d+)',
					redirect: to => ({
						name: 'actions.actions.show',
						params: { actionId: to.params.actionId },
					}),
				},
				{
					name: 'actions.permalinks.timeline',
					path: ':actionId(\\d+)/timeline',
					redirect: to => ({
						name: 'actions.actions.show',
						params: { actionId: to.params.actionId },
						query: { tab: 'timeline' },
					}),
				},
			],
		},
		{
			name: 'actions.actions',
			path: 'actions',
			redirect: { name: 'actions.actions.index' },
			children: [
				{
					name: 'actions.actions.index',
					path: '',
					component: () => import('#modules/actions/pages/ActionsIndex.vue'),
					meta: { permissions: ['actions.actions.index'] },
				},
				{
					name: 'actions.actions.create',
					path: 'create',
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/actions/pages/ActionPage.vue'),
					meta: { permissions: ['actions.actions.create'] },
				},
				{
					name: 'actions.actions.show',
					path: ':actionId(\\d+)',
					props: route => ({
						isNew: false,
						isEdit: false,
						actionId: Number(route?.params?.actionId),
					}),
					component: () => import('#modules/actions/pages/ActionPage.vue'),
					meta: { permissions: ['actions.actions.show'] },
				},
				{
					name: 'actions.actions.edit',
					path: ':actionId(\\d+)/edit',
					props: route => ({ isNew: false, isEdit: true, actionId: route?.params?.actionId }),
					component: () => import('#modules/actions/pages/ActionPage.vue'),
					meta: { permissions: ['actions.actions.update'] },
				},
			],
		},
	],
}

export default actionsRoutes
